import { Collapse, List, ListItem, ListItemText, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { Fragment, ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useCallback } from 'react';
import { DisabledProfilingMenu } from 'shell/view-models/disabled-menu';
import { useRouteAuthorization } from 'shell/hooks/use-route-authorization';
import { systemRoutes } from 'system/router/routing-config';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: `${theme.spacing(4)} !important`,
    },
    nestedIcon: {
      minWidth: 'auto !important',
      paddingRight: theme.spacing(2),
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
    colorItems: {
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
  })
);

interface ProfilingCollapseProps {
  onSubItemClick?: () => void;
  link: string;
  active: DisabledProfilingMenu;
}

const ProfilingCollapse = ({
  onSubItemClick,
  link,
  active,
}: ProfilingCollapseProps): ReactElement => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  const items = useRouteAuthorization(systemRoutes[0].children[0].children);

  return (
    <Fragment>
      <ListItem
        button
        key="Tabelle di Amministrazione"
        onClick={() => {
          handleClick();
        }}
        sx={{ pl: 6 }}
        className={classes.colorItems}
      >
        <ListItemText className={classes.colorItems} primary="Tabelle di Amministrazione" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {items
            .filter((route) => !route.hidden)
            .map((systemRoute) => (
              <Link
                key={`${link}/${systemRoute.path}`}
                to={`${link}/${systemRoute.path}`}
                className="pmi-anchor"
              >
                <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                  <ListItemText className={classes.colorItems} primary={systemRoute.name} />
                </ListItem>
              </Link>
            ))}
          {active.group ? (
            <Link key={`${link}/gruppi`} to={`${link}/gruppi`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Gruppi" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.profile ? (
            <Link key={`${link}/profili`} to={`${link}/profili`} className="pmi-anchor">
              <ListItem button key="profili" onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Profili" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.profile && active.group ? (
            <Link key={`${link}/funzioni`} to={`${link}/funzioni`} className="pmi-anchor">
              <ListItem button key="Funzioni" onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Funzioni" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.featureAuth ? (
            <Link key={`${link}/feature-auth`} to={`${link}/feature-auth`} className="pmi-anchor">
              <ListItem button key="Tipo-feature-auth" onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Autorizzazioni" />
              </ListItem>
            </Link>
          ) : undefined}
          {/* {active.featureAuthValue ? (
            <Link
              key={`${link}/feature-valore`}
              to={`${link}/feature-valore`}
              className="pmi-anchor"
            >
              <ListItem button key="feature-valore" onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Feature auth valore" />
              </ListItem>
            </Link>
          ) : undefined} */}
          {active.numerator ? (
            <Link key={`${link}/numeratori`} to={`${link}/numeratori`} className="pmi-anchor">
              <ListItem button key="Numeratori" onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Numeratori" />
              </ListItem>
            </Link>
          ) : undefined}
        </List>
      </Collapse>
    </Fragment>
  );
};

ProfilingCollapse.displayName = 'Profiling Collapse Item';

export default ProfilingCollapse;
